<template>
  <div class="c-notifications">
    <v-tabs v-model="tabIdx">
      <v-tab v-for="n in tabs" :key="n.flag"> {{ n.label }} </v-tab>
      <v-tab-item v-for="n in tabs" :key="n.flag">
        <template v-if="n.flag == 1">
          <div class="notify" v-for="m in cNotifications" :key="m.id || m.ts">
            <div class="notify-icon">
              <v-icon dark>notifications</v-icon>
            </div>
            <div class="notify-info">
              <p v-html="m.msg" />
              <div class="other">
                {{ m.ts | formatDatetime }}
                <v-btn class="acts" small outline v-if="m.func" @click="onDetail(m)">
                  详情
                </v-btn>
              </div>
            </div>
          </div>
        </template>
        <div class="notice" :class="[sn.log ? 'read' : 'un-read']"
          v-for="(sn, idx) in [[], sNotices, oNotices, mNotices][n.flag]" :key="sn.n.id">
          <div class="notice-icon">
            <v-icon dark>{{ sn.log ? "check" : "email" }}</v-icon>
          </div>
          <div class="notice-info">
            <h5 class="name">{{ sn.n.title }}</h5>
            <p class="desc" v-if="sn.n.desc">{{ sn.n.desc }}</p>
            <div class="appendix" v-if="sn.n.pdf || sn.n.videoId">
              <v-tooltip v-if="sn.n.videoId" top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" size="16" :color="sn.log ? '' : 'white'" style="cursor: pointer"
                    @click="onPlayVideo(sn.n.videoId)">play_circle_outline</v-icon>
                </template>
                <span>播放关联视频</span>
              </v-tooltip>
              <v-tooltip v-if="sn.n.pdf" top>
                <template v-slot:activator="{ on }">
                  <v-icon small>attach_file</v-icon>
                  <a v-on="on" target="_blank" :href="`${baseUrl}/home/my/notice/pdf/${sn.n.id}/${
                    sn.n.pdf.split('/')[0]
                  }`">{{ sn.n.pdf.split("/")[1] }}</a>
                </template>
                <span>打开附件</span>
              </v-tooltip>
            </div>
            <div class="other">
              <span class="time">{{ sn.createTime | formatDate }}</span>
              <v-btn outline small v-if="!sn.log" class="acts" @click="onFlagRead(n.flag, idx, sn.n.id)">
                标记已读
              </v-btn>
            </div>
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
export default {
  name: "notifications",
  data() {
    return {
      sNotices: [],
      mNotices: [],
      oNotices: [],
      tabIdx: 0,
      sCount: 0,
      mCount: 0,
      oCount: 0,
      sUrCount: 0,
      mUrCount: 0,
      oUrCount: 0,
      baseUrl: this.$const.baseUrl,
    };
  },
  watch: {
    cNotifications() {
      let self = this,
        cCount = self.cNotifications ? self.cNotifications.length : 0;
      self.$store.commit("notificationCount", {
        total: self.sCount + self.mCount + self.oCount + cCount,
        unRead: self.sUrCount + self.mUrCount + self.oUrCount,
      });
    },
    tabIdx(idx) {
      this.load(idx);
    },
  },
  computed: {
    cNotifications() {
      return this.$store.state.notifications;
    },
    tabs() {
      let tmp = [],
        cCount = this.cNotifications ? this.cNotifications.length : 0;
      if (this.sCount + cCount > 0) {
        tmp.push({ label: "平台", flag: 1 });
      }
      if (this.mCount > 0) {
        tmp.push({ label: "行管", flag: 3 });
      }
      if (this.oCount > 0) {
        tmp.push({ label: "企业", flag: 2 });
      }
      return tmp;
    },
  },
  methods: {
    onPlayVideo(vid) {
      let self = this;
      self.$axios.get(`/home/my/media/cc/url/${vid}`).then((r) => {
        if (r.data && r.data.status == "ok" && r.data.message) {
          self.$dialog.component("视频播放", "cc-video-viewer", {
            movieUrl: r.data.message,
          });
        }
      });
    },
    onFlagRead(flag, idx, id) {
      let self = this;
      self.$axios.get(`/home/my/notice/flag/read/${id}`).then((r) => {
        if (r.data.status != "ok") {
          return;
        }
        let arr = null;
        if (flag == 1) {
          arr = self.sNotices;
        } else if (flag == 2) {
          arr = self.oNotices;
        } else {
          arr = self.mNotices;
        }

        let sn = arr[idx];
        sn.log = true;
        self.$set(arr, idx, sn);
      });
    },
    onDetail(n) {
      n.func.apply(this);
    },
    load(idx) {
      let self = this,
        tab = self.tabs[idx];

      if (tab && !tab.ld) {
        tab.ld = true;
        self.$axios.get(`/home/my/notice/list/${tab.flag}/0/30`).then((r) => {
          if (r.data.status != "ok") {
            return;
          }

          let arr = r.data.message;
          if (!arr) {
            return;
          }

          if (tab.flag == 1) {
            self.sNotices = arr;
          } else if (tab.flag == 2) {
            self.oNotices = arr;
          } else {
            self.mNotices = arr;
          }
        });
      }
    },
    init() {
      let self = this,
        a = self.$store.state.account;
      if (!a || !a.id) {
        return;
      }
      //非系统管理员和监管账号，可以获取信息.
      if (a.type == 1 && a.tenantId != 0) {
        self.$axios.get("/home/my/notice/summary").then((r) => {
          if (r.data.status != "ok") {
            return;
          }
          r = r.data.message;
          let total = 0,
            unRead = 0;
          if (r.sc) {
            total += r.sc[0] + r.sc[1];
            unRead += r.sc[0];
            self.sUrCount += r.sc[0];
            self.sCount = r.sc[0] + r.sc[1];
          }

          if (r.mc) {
            total += r.mc[0] + r.mc[1];
            unRead += r.mc[0];
            self.mUrCount += r.mc[0];
            self.mCount = r.mc[0] + r.mc[1];
          }

          if (r.oc) {
            total += r.oc[0] + r.oc[1];
            unRead += r.oc[0];
            self.oUrCount += r.oc[0];
            self.oCount = r.oc[0] + r.oc[1];
          }

          let cNotices = self.cNotifications;
          if (cNotices) {
            total += cNotices.length;
            unRead += cNotices.length;
          }

          self.$store.commit("notificationCount", {
            total: total,
            unRead: unRead,
          });

          self.load(0);
        });
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.c-notifications .notify {
  padding: 10px 0;
  border-radius: 4px;
  font-size: 10px;
  color: #888;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #ddd;
}

.notify .notify-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: rgb(250, 200, 88);
}

.notify .notify-info {
  flex-grow: 1;
}

.notify .notify-info .other {
  margin-top: 12px;
  font-size: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notify .notify-info .other .acts {
  margin: 0;
  cursor: pointer;
  color: rgb(0, 104, 183);
}

.notify .notice-icon {
  background-color: rgb(250, 200, 88);
}

.c-notifications .notify p {
  color: orange;
  margin-bottom: 0;
}

.c-notifications .notify span {
  float: right;
  cursor: pointer;
  color: var(--v-primary-base);
}

.notice {
  padding: 10px 0;
  border-radius: 4px;
  font-size: 10px;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #ddd;
}

.notice .notice-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
  border-radius: 50%;
}

.notice .notice-info {
  flex-grow: 1;
}

.notice.read .notice-icon {
  background-color: #ddd;
}

.notice.un-read .notice-icon {
  background-color: rgb(250, 200, 88);
}

.notice .name {
  font-size: 14px;
  margin-bottom: 5px;
}

.notice.read .name {
  font-weight: normal;
}

.notice .desc {
  margin-top: 8px;
  margin-bottom: 0;
}

.notice .appendix {
  margin-top: 8px;
  margin-bottom: 0;
}

.notice .other {
  margin-top: 12px;
  font-size: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notice.read .other {
  color: #888;
}

.notice .other .acts {
  float: right;
  margin: 0;
  cursor: pointer;
  color: rgb(0, 104, 183);
}

.notice a {
  color: rgb(0, 104, 183);
  text-decoration: none;
}
</style>
